import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware, combineReducers, } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import persistStorage from 'redux-persist/es/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension';
export class StoreBuilder {
    constructor(reducerRegistery, initialState = { dynamic: {} }) {
        this.middlewares = [];
        this.persistConfig = {
            key: 'root',
            storage: persistStorage,
            stateReconciler: autoMergeLevel2,
            // https://github.com/rt2zz/redux-persist/issues/786
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            timeout: null,
        };
        this.loggerConfig = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.rootSagas = [];
        this.reducerRegistery = reducerRegistery;
        this.initialState = Object.assign({ dynamic: Object.assign({}, initialState.dynamic) }, initialState);
    }
    configureSaga(context) {
        this.context = context;
        this.sagaMiddleware = createSagaMiddleware({
            context,
        });
        this.middlewares.push(this.sagaMiddleware);
        return this;
    }
    configureLogger(enableOrOption) {
        if (enableOrOption !== false) {
            const opt = Object.assign(Object.assign({}, this.loggerConfig), (typeof enableOrOption !== 'boolean' ? enableOrOption : {}));
            this.middlewares.push(createLogger(opt));
        }
        return this;
    }
    configurePersistor(config) {
        this.persistConfig = Object.assign(Object.assign({}, this.persistConfig), config);
        return this;
    }
    addMiddleware(middleware) {
        this.middlewares.push(middleware);
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addRootSagas(sagas) {
        this.rootSagas = sagas;
        return this;
    }
    build() {
        if (!this.sagaMiddleware)
            throw new Error('Saga middleware was not configured.');
        if (!this.context)
            throw new Error('Context must be configured using configureContext method');
        const reducers = this.combine(this.reducerRegistery.getReducers(), this.reducerRegistery.getDynamicReducers(), [], this.initialState);
        const persistedReducer = persistReducer(this.persistConfig, reducers);
        const ifDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
        const store = createStore(persistedReducer, this.initialState, !ifDev
            ? applyMiddleware(...this.middlewares)
            : composeWithDevTools(applyMiddleware(...this.middlewares)));
        const persistor = persistStore(store);
        this.reducerRegistery.addChangeListener('default', (newReducers, newDynamicReducers, persistBlacklistedDynamicReducers) => {
            store.replaceReducer(persistReducer(this.persistConfig, this.combine(newReducers, newDynamicReducers, persistBlacklistedDynamicReducers, store.getState())));
            persistor.persist();
        });
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.rootSagas.map((saga) => this.sagaMiddleware.run(saga));
        return {
            store,
            reducerRegistry: this.reducerRegistery,
            runSaga: this.sagaMiddleware.run,
            context: this.context,
        };
    }
    combine(reducers, dynamicReducers, persistBlacklistedDynamicReducers, currentState = null) {
        const reducerNames = Object.keys(reducers);
        const dynamicReducerNames = Object.keys(dynamicReducers);
        Object.keys(currentState || this.initialState).forEach((item) => {
            if (reducerNames.indexOf(item) === -1) {
                // eslint-disable-next-line @typescript-eslint/ban-types
                reducers[item] = (state = null) => state;
            }
        });
        Object.keys((currentState && currentState.dynamic) || {}).forEach((item) => {
            if (dynamicReducerNames.indexOf(item) === -1) {
                // eslint-disable-next-line @typescript-eslint/ban-types
                dynamicReducers[item] = (state = null) => state;
            }
        });
        if (dynamicReducerNames.length > 0) {
            reducers.dynamic = persistReducer(Object.assign(Object.assign({}, this.persistConfig), { key: `${this.persistConfig.key}.dynamic`, whitelist: undefined, blacklist: persistBlacklistedDynamicReducers }), combineReducers(dynamicReducers));
        }
        return combineReducers(reducers);
    }
}
//# sourceMappingURL=StoreBuilder.js.map